import React from 'react';
import { Typography, Divider, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import ButtonLockedCTA from '@hydra/common/components/CTA/ButtonLockedCTA';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  heading: {
    padding: theme.spacing(4, 0)
  },
  title: {
    marginRight: theme.spacing(2)
  }
}));

const Header = ({ title, hasLockedButton = false }) => {
  const classes = useStyles();
  const { locale } = useI18n();
  return (
    <>
      <Container maxWidth='lg'>
        <Typography
          variant='h2'
          color='textPrimary'
          className={classes.heading}
        >
          <Translate content={title} className={classes.title} />
          {hasLockedButton && (
            <ButtonLockedCTA
              href={`/${locale}/user/plan`}
              size='md'
              hasTooltip
              tooltipTitle={<Translate content='pdf_editor_upgrade_locked_button_text' />}
            />
          )}
        </Typography>
      </Container>
      <Divider />
    </>
  );
};

export default Header;
